import { request } from '../request';

/**
 * 获取前台字典
 * GET /reference/dict-types/{type_code}/items
 *
 * @param typeCode 字典类型编码
 * @returns 字典类型包含的数据项列表
 */
export function fetchDictItems(typeCode: string) {
  return request<Api.Dict.PublicDictItemsResponse>({
    url: `/reference/dict-types/${typeCode}/items`,
    method: 'GET'
  });
}
